import type Sector from "@/types/Sector";
import type TicketType from "@/types/TicketType";

/**
 * The type's current batch is exhausted, or its Sector is. Max tickets per person and tickets in the cart do not
 * affect it. A type with no current batch at all isn't sold out by this rule, though it can't be bought either.
 *
 * Active holds are deliberately not counted, so the number shown is what most people would call available. The API
 * still counts them and can reject a contended reservation.
 */
export function isSoldOut(sector: Sector, type: TicketType): boolean {
  if (sector.capacity - sector.sold <= 0) return true;

  const batch = type.current_batch;

  if (!batch) return false;

  return batch.quantity !== null && batch.quantity - (batch.sold ?? 0) <= 0;
}
